import { PaymentStep } from '@features/FindSpecialist';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { motion } from 'framer-motion';
import { FC, useEffect } from 'react';
import { useMonitoringStore } from 'services/monitoring';

export const MonitoringV2Payment: FC = () => {
	const { navigateWithLanguage } = useLanguageNavigate();
	const { initialStepData } = useMonitoringStore();

	// Check if we have initial data, if not redirect to packages
	useEffect(() => {
		if (!initialStepData.id) {
			navigateWithLanguage('/farmer/services/monitoring-v2/packages');
		}
	}, [initialStepData.id, navigateWithLanguage]);

	return (
		<motion.div
			initial={{ opacity: 0, scale: 0.98 }}
			animate={{
				opacity: 1,
				scale: 1,
				transition: {
					duration: 0.5,
					type: 'spring',
					stiffness: 300,
					damping: 25,
				},
			}}
			className="monitoring-v2-page"
			style={{ overflow: 'visible', height: 'auto' }}
		>
			<PaymentStep />
		</motion.div>
	);
};
